import { CreateBatchBody, IBatch } from '@core/models/batch.model';
import { ISgtinScanValidation } from '@core/models/sgtin-scan.model';
import API from 'services/api';
import { fetchWithRetry } from 'services/fetchWithRetry';

class BatchService {
    private readonly addBatchURL = `/batches/add-batch`;
    private readonly getBatchesURL = `/batches/all`;
    private readonly validateScanURL = `/batches/validate-sgtin-scan`;
    // ---------------------------------------------------------------

    addBatch(body: CreateBatchBody) {
        return fetchWithRetry(API.post(this.addBatchURL, body));
    }

    getBatches(params: { pageSize: number; pageNumber: number }) {
        return fetchWithRetry(API.get(this.getBatchesURL, { params }));
    }

    getBatchById(id: number) {
        return fetchWithRetry(API.get<IBatch>(`/batches/${id}`));
    }

    validateSgtinScan(productId: number, rawScan: string) {
        return API.post<ISgtinScanValidation>(this.validateScanURL, { productId, rawScan });
    }
}

export default new BatchService();
